module.exports = __webpack_public_path__ + "img/alert-danger-circle.0764ef0f.svg";